// Import Libraries
import React, { useState } from 'react';
// Import JS Modules
import classNames from 'classnames';
import NewImageThumbnailSpinner from './new-image-thumbnail-spinner';

// -----------------------------------------------------------
//  NewProductImageThumbnail
// -----------------------------------------------------------
const NewProductImageThumbnail = ({
  thumbnail,
  isLoading,
  selected,
  onClickAction,
  index,
  viewClass,
}) => {
  const [loading, setLoading] = useState(isLoading);
  const [className, setClassName] = useState(viewClass);

  React.useEffect(() => {
    const img = new Image();
    img.src = thumbnail;
    img.onload = () => {
      setLoading(false);
    };
    img.onerror = () => {
      setLoading(false);
    };
  }, []);

  React.useEffect(() => {
    setClassName(viewClass);
  }, [viewClass]);

  return (
    <li className="list-inline-item rounded-circle">
      <div
        className={classNames(
          `_thumbnail-outer thumbnail align-items-center justify-content-center ${className} rounded-circle`,
          { loading: loading },
          { selected: selected }
        )}
        data-test-id="product-thumbnail-outer"
        onClick={handleClick}>
        <div
          className="square-background-thumbnail rounded-circle lazyload new-thumbnail-image w-100"
          data-bg={thumbnail}
        />
        <NewImageThumbnailSpinner />
      </div>
    </li>
  );

  function handleClick(event) {
    event.stopPropagation();

    onClickAction(index);
  }
};

export default NewProductImageThumbnail;
